/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReferralDocumentInput } from './ReferralDocumentInput';
import {
    ReferralDocumentInputFromJSON,
    ReferralDocumentInputFromJSONTyped,
    ReferralDocumentInputToJSON,
} from './ReferralDocumentInput';
import type { ReferralRecipientInput } from './ReferralRecipientInput';
import {
    ReferralRecipientInputFromJSON,
    ReferralRecipientInputFromJSONTyped,
    ReferralRecipientInputToJSON,
} from './ReferralRecipientInput';

/**
 * 
 * @export
 * @interface SendLeadReferralRequest
 */
export interface SendLeadReferralRequest {
    /**
     * 
     * @type {number}
     * @memberof SendLeadReferralRequest
     */
    sender_facility_id: number;
    /**
     * 
     * @type {number}
     * @memberof SendLeadReferralRequest
     */
    sender_organization_id: number;
    /**
     * 
     * @type {Date}
     * @memberof SendLeadReferralRequest
     */
    target_discharge_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof SendLeadReferralRequest
     */
    referral_type: SendLeadReferralRequestReferralTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SendLeadReferralRequest
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof SendLeadReferralRequest
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof SendLeadReferralRequest
     */
    ssn?: string;
    /**
     * 
     * @type {Date}
     * @memberof SendLeadReferralRequest
     */
    dob?: Date;
    /**
     * 
     * @type {Array<ReferralRecipientInput>}
     * @memberof SendLeadReferralRequest
     */
    recipients: Array<ReferralRecipientInput>;
    /**
     * 
     * @type {Array<ReferralDocumentInput>}
     * @memberof SendLeadReferralRequest
     */
    documents: Array<ReferralDocumentInput>;
    /**
     * Optional message broadcast to all recipients on referral creation
     * @type {string}
     * @memberof SendLeadReferralRequest
     */
    initial_message?: string;
}


/**
 * @export
 */
export const SendLeadReferralRequestReferralTypeEnum = {
    HomeHealth: 'home_health',
    Hospice: 'hospice',
    Snf: 'snf',
    Ltac: 'ltac',
    Dme: 'dme',
    Dialysis: 'dialysis',
    Other: 'other'
} as const;
export type SendLeadReferralRequestReferralTypeEnum = typeof SendLeadReferralRequestReferralTypeEnum[keyof typeof SendLeadReferralRequestReferralTypeEnum];


/**
 * Check if a given object implements the SendLeadReferralRequest interface.
 */
export function instanceOfSendLeadReferralRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sender_facility_id" in value;
    isInstance = isInstance && "sender_organization_id" in value;
    isInstance = isInstance && "referral_type" in value;
    isInstance = isInstance && "recipients" in value;
    isInstance = isInstance && "documents" in value;

    return isInstance;
}

export function SendLeadReferralRequestFromJSON(json: any): SendLeadReferralRequest {
    return SendLeadReferralRequestFromJSONTyped(json, false);
}

export function SendLeadReferralRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendLeadReferralRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sender_facility_id': json['sender_facility_id'],
        'sender_organization_id': json['sender_organization_id'],
        'target_discharge_date': !exists(json, 'target_discharge_date') ? undefined : (new Date(json['target_discharge_date'])),
        'referral_type': json['referral_type'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'ssn': !exists(json, 'ssn') ? undefined : json['ssn'],
        'dob': !exists(json, 'dob') ? undefined : (new Date(json['dob'])),
        'recipients': ((json['recipients'] as Array<any>).map(ReferralRecipientInputFromJSON)),
        'documents': ((json['documents'] as Array<any>).map(ReferralDocumentInputFromJSON)),
        'initial_message': !exists(json, 'initial_message') ? undefined : json['initial_message'],
    };
}

export function SendLeadReferralRequestToJSON(value?: SendLeadReferralRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sender_facility_id': value.sender_facility_id,
        'sender_organization_id': value.sender_organization_id,
        'target_discharge_date': value.target_discharge_date === undefined ? undefined : (value.target_discharge_date.toISOString().substring(0,10)),
        'referral_type': value.referral_type,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'ssn': value.ssn,
        'dob': value.dob === undefined ? undefined : (value.dob.toISOString().substring(0,10)),
        'recipients': ((value.recipients as Array<any>).map(ReferralRecipientInputToJSON)),
        'documents': ((value.documents as Array<any>).map(ReferralDocumentInputToJSON)),
        'initial_message': value.initial_message,
    };
}

